import Header from "./common/Header.js";
import Footer from "./common/Footer.js";
import MyselfDefault from "./images/MyselfDefault.svg";
import MyselfHover from "./images/MyselfHover.svg";
import MyselfSelected from "./images/MyselfSelected.svg";
import LovedOneDefault from "./images/LovedOneDefault.svg";
import LovedOneHover from "./images/LovedOneHover.svg";
import LovedOneSelected from "./images/LovedOneSelected.svg";
import Checkbox from "./common/Checkbox";
import Select from "react-select";

export default function SignupWizardEnrollment(props) {
  if (props.state.wizardStep !== "signup") {
    return null;
  }
  return (
    <div className="App" style={{ backgroundColor: props.state.wizardStep === "confirmation" ? "#4f196f" : "#f3f3f3" }}>
      <Header />
      <div>
        <div className="section center small apply">
          <h1 className="paragraph purple apply">Who are you applying for?</h1>
          <FlowTypeSelection
            state={props.state}
            handleChange={props.handleChange}
            errorHandler={props.errorHandler}
            setCaregiverFlow={props.setCaregiverFlow}
          />
        </div>

        <div>
          <form id="enrollment-form" onSubmit={props.handleEnrollment}>
            <SectionPersonal state={props.state} handleChange={props.handleChange} errorHandler={props.errorHandler} />
            <SectionPersonalForCaregiver
              state={props.state}
              handleChange={props.handleChange}
              errorHandler={props.errorHandler}
              handleSelectChange={props.handleSelectChange}
            />
            <SectionPersonalForLovedOne
              state={props.state}
              handleChange={props.handleChange}
              errorHandler={props.errorHandler}
            />
            <SectionContact state={props.state} handleChange={props.handleChange} errorHandler={props.errorHandler} />
            <SectionInvite
              state={props.state}
              handleChange={props.handleChange}
              errorHandler={props.errorHandler}
              toggleInviteCode={props.toggleInviteCode}
            />
            <div className="memberpod privacy" style={{ paddingBottom: "0px" }}>
              <div className="w-container">
                <div style={{ marginBottom: "25px", display: "table-row" }}>
                  <div style={{ display: "table-cell", verticalAlign: "middle" }}>
                    <label style={Object.assign({ margin: "0" }, props.errorHandler("termsAndPrivacyAccepted"))}>
                      <Checkbox checked={props.state.termsAndPrivacyAccepted} onChange={props.handleCheckboxChange} />
                    </label>
                  </div>
                  <div style={{ display: "table-cell", verticalAlign: "middle", paddingLeft: "15px" }}>
                    <label>
                      <span style={{ fontSize: "22px" }}>
                        I have read the{" "}
                        <a
                          href="https://getduos.com/terms-of-service"
                          target="_blank"
                          rel="noreferrer"
                          style={{ color: "#172e7d", textDecoration: "none" }}
                        >
                          terms of service
                        </a>{" "}
                        and{" "}
                        <a
                          href="https://getduos.com/privacy-policy"
                          target="_blank"
                          rel="noreferrer"
                          style={{ color: "#172e7d", textDecoration: "none" }}
                        >
                          privacy policy
                        </a>
                        .
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="memberpod privacy">
              <div className="w-container">
                <div style={{ marginBottom: "35px" }}>
                  <button
                    type="submit"
                    className="button-hero sub purple w-button"
                    style={{ width: "100%" }}
                    disabled={props.state.isEnrollmentSubmitting}
                  >
                    <span style={{ display: props.state.isEnrollmentSubmitting ? "none" : "block" }}>Apply Now</span>
                    <svg
                      style={{ display: props.state.isEnrollmentSubmitting ? "block" : "none" }}
                      className="spinner"
                      version="1.1"
                      id="L9"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      enableBackground="new 0 0 0 0"
                    >
                      <path
                        fill="#fff"
                        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
                      >
                        <animateTransform
                          attributeName="transform"
                          attributeType="XML"
                          type="rotate"
                          dur="1s"
                          from="0 50 50"
                          to="360 50 50"
                          repeatCount="indefinite"
                        />
                      </path>
                    </svg>
                  </button>
                  <p
                    style={{
                      display:
                        JSON.stringify(props.state.errors) !== "{}" && !props.state.errors?.inviteCode
                          ? "block"
                          : "none",
                      textAlign: "center",
                      color: "red",
                      fontWeight: "700",
                      marginTop: "10px",
                    }}
                  >
                    *Invalid values found in highlighted fields above, please fix and try again.
                  </p>
                  <p
                    style={{
                      display: props.state.errorMessage ? "block" : "none",
                      textAlign: "center",
                      color: "red",
                      fontWeight: "700",
                      marginTop: "10px",
                    }}
                  >
                    We are experiencing system issues at the moment, please try again later or give us a call. We
                    apologize for the inconvenience.
                  </p>
                  <p
                    style={{
                      display: props.state.errors?.inviteCode ? "block" : "none",
                      textAlign: "center",
                      color: "red",
                      fontWeight: "700",
                      marginTop: "10px",
                    }}
                  >
                    Invite code is no longer valid.
                  </p>
                </div>
                <div style={{ textAlign: "center" }}>
                  <p className="phoneBottomText">Call anytime to apply by phone</p>
                  <p>
                    <a href="tel:8552129242" onClick={() => (window.onbeforeunload = null)} className="telBottom">
                      855 212 9242
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

const FlowTypeSelection = (props) => {
  return (
    <div className="feature-wrap icons _3step survey">
      <div className="feature-content icons _3up center survey2 small">
        <img
          src={MyselfDefault}
          loading="lazy"
          alt=""
          className="signup1"
          onMouseOver={(e) => (e.currentTarget.src = MyselfHover)}
          onMouseOut={(e) => (e.currentTarget.src = MyselfDefault)}
          onClick={() => props.setCaregiverFlow(false)}
        />
        <img
          alt=""
          src={MyselfSelected}
          className="signup1"
          style={{ position: "absolute", display: props.state.caregiverFlow === true ? "none" : "block" }}
        />
        <p className="paragraph-3 purple mobile">For myself</p>
      </div>
      <div className="feature-content icons _3up center survey2 small">
        <img
          src={LovedOneDefault}
          loading="lazy"
          alt=""
          className="signup1"
          onMouseOver={(e) => (e.currentTarget.src = LovedOneHover)}
          onMouseOut={(e) => (e.currentTarget.src = LovedOneDefault)}
          onClick={() => props.setCaregiverFlow(true)}
        />
        <img
          alt=""
          src={LovedOneSelected}
          className="signup1"
          style={{ position: "absolute", display: props.state.caregiverFlow === true ? "block" : "none" }}
        />
        <p className="paragraph-3 purple mobile">For a loved one</p>
      </div>
    </div>
  );
};

const SectionPersonal = (props) => {
  if (props.state.caregiverFlow) {
    return null;
  }
  return (
    <div className="section wide img light gray apply">
      <div className="memberpod">
        <h2 className="heading-5 lightbg leftheading">Let&#x27;s get to know you</h2>
        <div className="w-container">
          <div className="contact-form-grid-2">
            <div className="collapseMobile">
              <label htmlFor="firstName" className="field-label left">
                First&nbsp;Name
              </label>
              <input
                value={props.state.firstName}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={props.errorHandler("firstName")}
                maxLength="256"
                name="firstName"
                placeholder=""
                id="firstName"
                required="required"
              />
            </div>
            <div className="collapseMobile">
              <label htmlFor="lastName" className="field-label">
                Last&nbsp;Name
              </label>
              <input
                value={props.state.lastName}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={props.errorHandler("lastName")}
                maxLength="256"
                name="lastName"
                placeholder=""
                id="lastName"
                required="required"
              />
            </div>
          </div>
          <div>
            <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2", whiteSpace: "nowrap" }}>
              <label htmlFor="birthMonth" className="field-label">
                Date of Birth
              </label>
              <input
                value={props.state.birthMonth}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={Object.assign(
                  { display: "inline-block", width: "75px", marginRight: "20px" },
                  props.errorHandler("birthMonth")
                )}
                maxLength="2"
                name="birthMonth"
                placeholder="MM"
                id="birthMonth"
                required="required"
                inputMode="numeric"
                pattern="\s*\d*\s*"
              />
              <input
                value={props.state.birthDay}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={Object.assign(
                  { display: "inline-block", width: "75px", marginRight: "20px" },
                  props.errorHandler("birthDay")
                )}
                maxLength="2"
                name="birthDay"
                placeholder="DD"
                id="birthDay"
                required="required"
                inputMode="numeric"
                pattern="\s*\d*\s*"
              />
              <input
                value={props.state.birthYear}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={Object.assign({ display: "inline-block", width: "125px" }, props.errorHandler("birthYear"))}
                maxLength="4"
                name="birthYear"
                placeholder="YYYY"
                id="birthYear"
                required="required"
                inputMode="numeric"
                pattern="\s*\d*\s*"
              />
            </div>
            <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
              <label htmlFor="zip" className="field-label">
                Zip Code
              </label>
              <input
                value={props.state.zip}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={Object.assign({ marginBottom: "0px", width: "200px" }, props.errorHandler("zip"))}
                maxLength="256"
                name="zip"
                placeholder=""
                id="zip"
                required="required"
                inputMode="numeric"
                pattern="\s*\d*\s*"
              />
              <label htmlFor="zip" className="caption">
                Duos is personalized based on location.
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SectionPersonalForCaregiver = (props) => {
  if (!props.state.caregiverFlow) {
    return null;
  }
  const relationshipOptions = [
    { value: "My Parent", label: "My Parent" },
    { value: "My Friend", label: "My Friend" },
    { value: "My Relative", label: "My Relative" },
    { value: "Caregiver", label: "Caregiver" },
  ];

  const dropdownIndicatorStyles = (base, state) => {
    let changes = {
      // all your override styles
      color: "#4f196f",
    };
    return Object.assign(base, changes);
  };

  const singleValueStyles = (base, state) => {
    let changes = {
      // all your override styles
      color: "#4f196f",
    };
    return Object.assign(base, changes);
  };

  const optionStyles = (base, state) => {
    let changes = {
      // all your override styles
      color: state.isFocused ? "#ffffff" : "#4f196f",
      backgroundColor: state.isFocused ? "#4f196f" : "#ffffff",
      ":hover": {
        backgroundColor: "#4f196f",
        color: "#fff",
      },
    };
    return Object.assign(base, changes);
  };

  const menuStyles = (base, state) => {
    let changes = {
      // all your override styles
      display: "block",
      color: "#4f196f",
      fontSize: "18px",
      fontWeight: "700",
    };
    return Object.assign(base, changes);
  };

  const controlStyles = (base, state) => {
    let changes = {
      // all your override styles
      width: "100%",
      maxWidth: "500px",
      height: "55px",
      borderStyle: "solid",
      borderWidth: "2px",
      borderColor: "#4f196f",
      borderRadius: "4px",
      backgroundColor: "#fff",
      color: "#4f196f",
      fontSize: "18px",
      fontWeight: "700",
      whiteSpace: "normal",
      backgroundClip: "border-box",
      boxShadow: "",
      ":focus": {
        borderColor: "#4f196f",
        boxShadow: "0 0 0 1px #4f196f",
      },
      ":focus-within": {
        borderColor: "#4f196f",
        boxShadow: "0 0 0 1px #4f196f",
      },
      ":hover": {
        borderColor: "#4f196f",
        boxShadow: "0 0 0 1px #4f196f",
      },
      ":active": {
        boxShadow: "0 0 0 1px #4f196f",
      },
    };
    return Object.assign(base, changes, props.errorHandler("caregiverRelationship"));
  };

  return (
    <div className="section wide img light gray apply">
      <div className="memberpod">
        <h2 className="heading-5 lightbg leftheading">Let&apos;s get to know you</h2>
        <div className="w-container">
          <div className="contact-form-grid-2">
            <div className="collapseMobile">
              <label htmlFor="caregiverFirstName" className="field-label left">
                First Name
              </label>
              <input
                value={props.state.caregiverFirstName}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={props.errorHandler("caregiverFirstName")}
                maxLength="256"
                name="caregiverFirstName"
                placeholder=""
                id="caregiverFirstName"
                required="required"
              />
            </div>
            <div className="collapseMobile">
              <label htmlFor="caregiverLastName" className="field-label">
                Last Name
              </label>
              <input
                value={props.state.caregiverLastName}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={props.errorHandler("caregiverLastName")}
                maxLength="256"
                name="caregiverLastName"
                placeholder=""
                id="caregiverLastName"
                required="required"
              />
            </div>
          </div>
          <div>
            <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
              <label htmlFor="caregiverPhone" className="field-label">
                Phone
              </label>
              <input
                value={props.state.caregiverPhone}
                onChange={props.handleChange}
                type="tel"
                className="text-field memberinput w-input"
                style={Object.assign({ width: "100%", maxWidth: "500px" }, props.errorHandler("caregiverPhone"))}
                maxLength="256"
                name="caregiverPhone"
                placeholder="555-555-5555"
                id="caregiverPhone"
                required="required"
              />
            </div>
            <p
              style={{
                display: props.state.errors.conflict && props.state.errors.caregiverPhone ? "block" : "none",
                color: "red",
                fontWeight: "700",
                marginBottom: "32px",
              }}
            >
              The phone number you’ve entered already exists. If you believe this to be an error, please call 855 212
              9242, or enter a new phone number.
            </p>

            <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
              <label htmlFor="caregiverEmail" className="field-label">
                Email (optional)
              </label>
              <input
                value={props.state.caregiverEmail}
                onChange={props.handleChange}
                type="email"
                className="text-field memberinput w-input"
                style={Object.assign({ width: "100%", maxWidth: "500px" }, props.errorHandler("caregiverEmail"))}
                maxLength="256"
                name="caregiverEmail"
                placeholder=""
                id="caregiverEmail"
              />
            </div>

            <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
              <label htmlFor="caregiverRelationship" className="field-label">
                Relationship with your loved one
              </label>
              <Select
                options={relationshipOptions}
                placeholder="Select relationship"
                inputProps={{ readOnly: true }}
                isSearchable={false}
                onChange={props.handleSelectChange}
                value={relationshipOptions.filter((option) => option.value === props.state.caregiverRelationship)}
                components={{ IndicatorSeparator: () => null }}
                styles={{
                  option: optionStyles,
                  menu: menuStyles,
                  control: controlStyles,
                  dropdownIndicator: dropdownIndicatorStyles,
                  singleValue: singleValueStyles,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SectionPersonalForLovedOne = (props) => {
  if (!props.state.caregiverFlow) {
    return null;
  }
  return (
    <div className="section wide img light gray apply">
      <div className="memberpod">
        <h2 className="heading-5 lightbg leftheading">Tell us about your loved one</h2>
        <div className="w-container">
          <div className="contact-form-grid-2">
            <div>
              <label htmlFor="lovedOneFirstName" className="field-label left">
                First Name
              </label>
              <input
                value={props.state.lovedOneFirstName}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={props.errorHandler("lovedOneFirstName")}
                maxLength="256"
                name="lovedOneFirstName"
                placeholder=""
                id="lovedOneFirstName"
                required="required"
              />
            </div>
            <div>
              <label htmlFor="lovedOneLastName" className="field-label">
                Last Name
              </label>
              <input
                value={props.state.lovedOneLastName}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={props.errorHandler("lovedOneLastName")}
                maxLength="256"
                name="lovedOneLastName"
                placeholder=""
                id="lovedOneLastName"
                required="required"
              />
            </div>
          </div>
          <div>
            <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2", whiteSpace: "nowrap" }}>
              <label htmlFor="lovedOneBirthMonth" className="field-label">
                Their Date of Birth
              </label>
              <div>
                <input
                  value={props.state.lovedOneBirthMonth}
                  onChange={props.handleChange}
                  type="text"
                  className="text-field memberinput w-input"
                  style={Object.assign(
                    { display: "inline-block", width: "75px", marginRight: "20px" },
                    props.errorHandler("lovedOneBirthMonth")
                  )}
                  maxLength="2"
                  name="lovedOneBirthMonth"
                  placeholder="MM"
                  id="lovedOneBirthMonth"
                  required="required"
                  inputMode="numeric"
                  pattern="\s*\d*\s*"
                />
                <input
                  value={props.state.lovedOneBirthDay}
                  onChange={props.handleChange}
                  type="text"
                  className="text-field memberinput w-input"
                  style={Object.assign(
                    { display: "inline-block", width: "75px", marginRight: "20px" },
                    props.errorHandler("lovedOneBirthDay")
                  )}
                  maxLength="2"
                  name="lovedOneBirthDay"
                  placeholder="DD"
                  id="lovedOneBirthDay"
                  required="required"
                  inputMode="numeric"
                  pattern="\s*\d*\s*"
                />
                <input
                  value={props.state.lovedOneBirthYear}
                  onChange={props.handleChange}
                  type="text"
                  className="text-field memberinput w-input"
                  style={Object.assign(
                    { display: "inline-block", width: "125px", marginRight: "20px" },
                    props.errorHandler("lovedOneBirthYear")
                  )}
                  maxLength="4"
                  name="lovedOneBirthYear"
                  placeholder="YYYY"
                  id="lovedOneBirthYear"
                  required="required"
                  inputMode="numeric"
                  pattern="\s*\d*\s*"
                />
              </div>
            </div>
            <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
              <label htmlFor="lovedOne" className="field-label">
                Their Phone Number
              </label>
              <input
                value={props.state.lovedOnePhone}
                onChange={props.handleChange}
                type="tel"
                className="text-field memberinput w-input"
                style={Object.assign({ width: "100%", maxWidth: "500px" }, props.errorHandler("lovedOnePhone"))}
                maxLength="256"
                name="lovedOnePhone"
                placeholder="555-555-5555"
                id="lovedOnePhone"
                required="required"
              />
            </div>
            <p
              style={{
                display: props.state.errors.conflict && props.state.errors.lovedOnePhone ? "block" : "none",
                color: "red",
                fontWeight: "700",
                marginBottom: "32px",
              }}
            >
              The phone number you’ve entered already exists. If you believe this to be an error, please call 855 212
              9242, or enter a new phone number.
            </p>

            <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
              <label htmlFor="lovedOneEmail" className="field-label">
                Their Email (optional)
              </label>
              <input
                value={props.state.lovedOneEmail}
                onChange={props.handleChange}
                type="email"
                className="text-field memberinput w-input"
                style={Object.assign({ width: "100%", maxWidth: "500px" }, props.errorHandler("lovedOneEmail"))}
                maxLength="256"
                name="lovedOneEmail"
                placeholder=""
                id="lovedOneEmail"
              />
            </div>

            <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2", marginBottom: "40px" }}>
              <label htmlFor="lovedOneZip" className="field-label">
                Their Zip Code
              </label>
              <input
                value={props.state.lovedOneZip}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={Object.assign({ marginBottom: "0px", width: "200px" }, props.errorHandler("lovedOneZip"))}
                maxLength="256"
                name="lovedOneZip"
                placeholder=""
                id="lovedOneZip"
                required="required"
                inputMode="numeric"
                pattern="\s*\d*\s*"
              />
              <label htmlFor="lovedOneZip" className="caption">
                Duos is personalized based on location.
              </label>
            </div>

            <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
              <label htmlFor="lovedOneReason" className="field-label">
                Anything else you'd like us to know? (optional)
              </label>
              <textarea
                value={props.state.lovedOneReason}
                onChange={props.handleChange}
                className="text-field memberinput w-input"
                style={Object.assign(
                  { marginBottom: "0px", height: "auto", padding: "10px 15px" },
                  props.errorHandler("lovedOneReason")
                )}
                rows="3"
                placeholder="Ex. My mom lives alone and needs transportation services."
                maxLength="512"
                name="lovedOneReason"
                id="lovedOneReason"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SectionContact = (props) => {
  if (props.state.caregiverFlow) {
    return null;
  }
  return (
    <div className="section wide img light gray apply">
      <div className="memberpod">
        <h2 className="heading-5 lightbg leftheading">How can we contact you?</h2>
        <div>
          <label htmlFor="phone" className="field-label">
            Phone
          </label>
          <input
            value={props.state.phone}
            onChange={props.handleChange}
            type="tel"
            className="text-field memberinput w-input"
            style={Object.assign({ width: "100%", maxWidth: "500px" }, props.errorHandler("phone"))}
            maxLength="256"
            name="phone"
            placeholder="555-555-5555"
            id="phone"
            required="required"
            minLength="10"
          />
        </div>
        <p
          style={{
            display: props.state.errors.conflict && props.state.errors.phone ? "block" : "none",
            color: "red",
            fontWeight: "700",
            marginBottom: "32px",
          }}
        >
          The phone number you’ve entered already exists. If you believe this to be an error, please call 855 212 9242,
          or enter a new phone number.
        </p>
        <div>
          <label htmlFor="email" className="field-label">
            Email (optional)
          </label>
          <input
            value={props.state.email}
            onChange={props.handleChange}
            type="email"
            className="text-field memberinput w-input"
            style={Object.assign(
              { marginBottom: "0px", width: "100%", maxWidth: "500px" },
              props.errorHandler("email")
            )}
            maxLength="256"
            name="email"
            placeholder=""
            id="email"
          />
        </div>
      </div>
    </div>
  );
};

const SectionInvite = (props) => {
  return (
    <div className="section wide img light gray apply">
      <div className="memberpod invite" style={{ paddingBottom: "30px" }}>
        <div className="invitecode" style={{ marginBottom: "0px" }}>
          <a
            href="#/"
            role="button"
            onClick={(ev) => {
              ev.preventDefault();
              props.toggleInviteCode();
            }}
            className="infoLink"
          >
            Do you have an invite code?
          </a>
        </div>
        <div style={{ marginTop: "30px", display: props.state.showInviteCode === true ? "block" : "none" }}>
          <h2 className="heading-5 lightbg leftheading sub">Enter your invite code</h2>
          <h6 className="subtitle">If you're applying through a third-party partner, they will provide your code.</h6>
          <div className="formfield half">
            <input
              value={props.state.inviteCode}
              onChange={props.handleChange}
              type="text"
              className="text-field memberinput w-input"
              style={{ ...props.errorHandler("inviteCode"), minWidth: "300px", width: "50%" }}
              maxLength="256"
              name="inviteCode"
              placeholder=""
              id="inviteCode"
              required=""
            />
          </div>
          <label id="contact-email" className="caption invite">
            Can’t find your invite code? Give us a call 855-212-9242.
          </label>
        </div>
      </div>
    </div>
  );
};
